export default objects => {
	return objects[0]?.nextElementSibling;
}
